/**
 * Reasons listicle (Maggie's)
 * Minimal JavaScript for countdown timer and floating CTA
 */

// Count-Up Timer (starts from 2 minutes)
(function initCountUp() {
  const minutesEl = document.getElementById('minutesUp');
  const secondsEl = document.getElementById('secondsUp');

  if (!minutesEl || !secondsEl) return;

  // Start from 2 minutes ago
  const startTime = Date.now() - (2 * 60 * 1000);

  function updateTimer() {
    const elapsed = Date.now() - startTime;

    const minutes = Math.floor(elapsed / (1000 * 60));
    const seconds = Math.floor((elapsed / 1000) % 60);

    minutesEl.textContent = String(minutes).padStart(2, '0');
    secondsEl.textContent = String(seconds).padStart(2, '0');
  }

  updateTimer();
  setInterval(updateTimer, 1000);
})();

// Floating CTA - Show after 500px scroll, hide at footer
(function initFloatingCTA() {
  const floatingCTA = document.getElementById('floating-cta');
  const footer = document.querySelector('footer');
  if (!floatingCTA) return;

  function checkScroll() {
    const scrollY = window.scrollY;
    const windowHeight = window.innerHeight;
    const docHeight = document.documentElement.scrollHeight;

    // Check if we're at the bottom (within 100px of footer)
    const atBottom = (scrollY + windowHeight) >= (docHeight - 100);

    if (scrollY > 500 && !atBottom) {
      floatingCTA.classList.add('visible');
    } else {
      floatingCTA.classList.remove('visible');
    }
  }

  window.addEventListener('scroll', checkScroll);
  checkScroll();
})();

// Dynamic year in footer
(function updateYear() {
  const yearEl = document.querySelector('.current-year');
  if (yearEl) yearEl.textContent = new Date().getFullYear();
})();

// Social Proof Counter - Dynamic updates
(function initSocialProof() {
  const giftsEl = document.getElementById('gifts-counter');
  if (!giftsEl) return;

  let gifts = 113100;

  function formatCompact(n) {
    return (n / 1000).toFixed(1) + 'K';
  }

  // Update gifts every 4-8 seconds
  function updateGifts() {
    gifts += Math.floor(Math.random() * 80) + 20; // +20 to +99
    giftsEl.textContent = formatCompact(gifts);
    setTimeout(updateGifts, 4000 + Math.random() * 4000);
  }

  setTimeout(updateGifts, 3000);
})();

// Custom Slider
class Slider {
  constructor(el) {
    this.container = el;
    this.mask = el.querySelector('.slider-mask');
    this.slides = el.querySelectorAll('.slide');
    this.current = 0;
    this.total = this.slides.length;
    this.slideHeights = [];

    if (this.total > 0) {
      this.measureHeights();
      this.createNav();
      this.bindEvents();
      this.update();
    }
  }

  measureHeights() {
    // Measure all slide heights on init (before transforms cause issues)
    this.slides.forEach((slide, i) => {
      this.slideHeights[i] = slide.offsetHeight;
    });
  }

  createNav() {
    const nav = this.container.querySelector('.slider-nav');
    if (nav && this.total > 1) {
      this.dots = [];
      for (let i = 0; i < this.total; i++) {
        const dot = document.createElement('button');
        dot.className = 'slider-dot';
        dot.setAttribute('type', 'button');
        dot.addEventListener('click', () => this.goTo(i));
        nav.appendChild(dot);
        this.dots.push(dot);
      }
    }
  }

  bindEvents() {
    const leftBtn = this.container.querySelector('.slider-arrow.left');
    const rightBtn = this.container.querySelector('.slider-arrow.right');
    if (leftBtn) leftBtn.addEventListener('click', () => this.prev());
    if (rightBtn) rightBtn.addEventListener('click', () => this.next());

    // Re-measure heights on window resize
    window.addEventListener('resize', () => this.measureHeights());

    // Touch swipe support - attach to container (stable), not mask (moves with transform)
    let startX = 0;
    let startY = 0;
    this.container.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });

    this.container.addEventListener('touchend', (e) => {
      const endX = e.changedTouches[0].clientX;
      const endY = e.changedTouches[0].clientY;
      const diffX = startX - endX;
      const diffY = startY - endY;

      // Only swipe if horizontal movement > vertical and > 50px
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
        if (diffX > 0) {
          this.next();
        } else {
          this.prev();
        }
      }
    }, { passive: true });
  }

  goTo(index) {
    this.current = (index + this.total) % this.total;
    this.update();
  }

  prev() { this.goTo(this.current - 1); }
  next() { this.goTo(this.current + 1); }

  update() {
    if (this.mask) {
      this.mask.style.transform = `translateX(-${this.current * 100}%)`;
      // Animate to current slide's height
      const height = this.slideHeights[this.current];
      if (height) {
        this.mask.style.height = height + 'px';
      }
    }
    this.dots?.forEach((dot, i) => {
      dot.classList.toggle('active', i === this.current);
    });
  }
}

// Initialize sliders when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSliders);
} else {
  initSliders();
}

function initSliders() {
  document.querySelectorAll('.slider').forEach(el => {
    const s = new Slider(el);
    // Logos and webfonts can land after init; re-measure whenever a slide changes size
    // so the dots always sit below the text
    const remeasure = () => { s.measureHeights(); s.update(); };
    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(remeasure);
      s.slides.forEach(slide => ro.observe(slide));
    }
    el.querySelectorAll('img').forEach(img => img.addEventListener('load', remeasure));
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(remeasure);
    window.addEventListener('load', remeasure);
  });
}

// Scroll-press videos: visibility-aware play/pause to respect Safari mobile's
// concurrent-decode limit (~3-6 videos on iPhone). Only videos currently in the
// viewport get play()'d; the rest are paused (showing their last frame / poster).
// Also uses JS-rewind to avoid Safari's native-loop end-of-video flash bug.
(function initScrollPressVideos() {
  const videos = document.querySelectorAll('.video-scroll-item');
  if (!videos.length) return;

  const safePlay = v => {
    const p = v.play();
    if (p && typeof p.catch === 'function') p.catch(() => {});
  };

  videos.forEach(v => {
    v.removeAttribute('loop');

    // Rewind before native end — bypasses Safari's loop flash
    v.addEventListener('timeupdate', () => {
      if (v.duration && v.currentTime >= v.duration - 0.18) {
        v.currentTime = 0;
        safePlay(v);
      }
    });

    // Toggle visibility class so poster <img> shows through
    // whenever the video isn't actively rendering frames
    v.addEventListener('playing', () => v.classList.add('is-playing'));
    v.addEventListener('pause', () => v.classList.remove('is-playing'));
    v.addEventListener('waiting', () => v.classList.remove('is-playing'));
    v.addEventListener('emptied', () => v.classList.remove('is-playing'));
    v.addEventListener('stalled', () => v.classList.remove('is-playing'));
  });

  // No IntersectionObserver support → fall back to playing all
  if (!('IntersectionObserver' in window)) {
    videos.forEach(safePlay);
    return;
  }

  // Prime initially-visible videos synchronously so they start without
  // waiting for IO's async first firing
  const vw = window.innerWidth;
  videos.forEach(v => {
    const r = v.getBoundingClientRect();
    if (r.right >= -200 && r.left <= vw + 200) safePlay(v);
  });

  // Only decode videos visible in the viewport; pause the rest
  const io = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        safePlay(entry.target);
      } else {
        entry.target.pause();
      }
    });
  }, {
    rootMargin: '0px 200px', // start playing ~200px before entering view horizontally
    threshold: 0,
  });

  videos.forEach(v => io.observe(v));
})();

// Carry ad parameters (utm, fbclid) from this page onto every buy link
(function forwardParams() {
  if (!location.search) return;
  const incoming = new URLSearchParams(location.search);
  document.querySelectorAll('a[href]').forEach(a => {
    const href = a.getAttribute('href');
    if (!href || href.startsWith('#') || a.hasAttribute('data-ignore')) return;
    const url = new URL(href, location.origin);
    if (url.origin !== location.origin) return;
    incoming.forEach((v, k) => { if (!url.searchParams.has(k)) url.searchParams.set(k, v); });
    a.setAttribute('href', url.pathname + url.search + url.hash);
  });
})();
